<template>
  <JMenu :modelValue="currencyStore.currency" :options="options" class="px-0">
    <template #menuButton>
      <div
        class="flex flex-row items-center gap-4"
        @click="setRecentActivityToCurrency"
      >
        <JIcon name="dollar" size="20" class="text-dark" />
        <span class="font-medium text-dark">
          {{ currencyStore.currency?.title }}
        </span>
      </div>
    </template>

    <template #listItem="{ menuItem }">
      <JMenuItem
        :option="menuItem"
        :selectedItem="menuItem.isSelected"
        class="-mx-10 cursor-pointer !px-14"
        :class="menuItem.isDefault ? 'border-b border-gray-250' : ''"
        @click=";(selectedCurrency = menuItem as Currency), onChangeCurrency()"
      >
        <template #item>
          <div class="flex min-w-[9rem] items-center justify-between">
            <span class="font-medium">{{ menuItem.title }}</span>
            <JIcon
              v-show="menuItem.isSelected"
              name="tick-circle"
              class="text-primary"
            />
          </div>
        </template>
      </JMenuItem>
    </template>
  </JMenu>
  <ChangeCurrencyConfirmationDialog
    v-model="isCurrencyInformationDialogOpen"
    @confirm="onConfirmChangeCurrency"
  />
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { JIcon, JMenu, JMenuItem } from '@journey/ui-kit'
import { useCurrency } from '@/modules/Core/composables'
import useCurrencyStore from '@/modules/Core/store/currency'
import useHelpStore from '@/modules/Help/store'
import ChangeCurrencyConfirmationDialog from '@/modules/Core/components/layout/Header/HeaderContent/ChangeCurrencyConfirmationDialog/ChangeCurrencyConfirmationDialog.vue'
import type { Currency } from '@/modules/Core/types/model/currency'
import useItinerarySummary from '@/modules/Search/store/itinerarySummary'
import { HELP_SECTIONS } from '@/modules/Core/constants'

const { currencyOptions } = useCurrency()
const currencyStore = useCurrencyStore()
const itinerarySummary = useItinerarySummary()

const router = useRouter()
const isCurrencyInformationDialogOpen = ref(false)
const selectedCurrency = ref(currencyStore.currency)

const options = computed(() => {
  return currencyOptions.value
    .map((item) => ({
      ...item,
      isSelected: item.symbol === selectedCurrency.value.symbol,
    }))
    .sort((a, b) => (a.isDefault ? -1 : a.title > b.title ? 1 : -1))
})

// RECENT ACTIVITY
const helpStore = useHelpStore()

function onChangeCurrency() {
  if (!itinerarySummary.itineraryLength) {
    currencyStore.setCurrency(selectedCurrency.value)
    return
  }

  isCurrencyInformationDialogOpen.value = true
}

function onConfirmChangeCurrency() {
  currencyStore.setCurrency(selectedCurrency.value)
  if (router.currentRoute.value.path !== '/') {
    router.push('/')
  }
}

function setRecentActivityToCurrency() {
  helpStore.setRecentActivity(HELP_SECTIONS.LanguageOrCurrency)
}
</script>
